/** Standard binary min-heap. Items are ordered by the comparator passed to the constructor. */
export class MinHeap<T> {
	private items: T[] = [];

	constructor(private compare: (a: T, b: T) => number) {}

	get size(): number {
		return this.items.length;
	}

	push(item: T): void {
		this.items.push(item);
		this.siftUp(this.items.length - 1);
	}

	pop(): T | undefined {
		if (this.items.length === 0) return undefined;
		const top = this.items[0];
		const last = this.items.pop()!;
		if (this.items.length > 0) {
			this.items[0] = last;
			this.siftDown(0);
		}
		return top;
	}

	private siftUp(i: number): void {
		while (i > 0) {
			const parent = (i - 1) >> 1;
			if (this.compare(this.items[i], this.items[parent]) >= 0) break;
			this.swap(i, parent);
			i = parent;
		}
	}

	private siftDown(i: number): void {
		const n = this.items.length;
		while (true) {
			const left = 2 * i + 1;
			const right = 2 * i + 2;
			let smallest = i;
			if (left < n && this.compare(this.items[left], this.items[smallest]) < 0) smallest = left;
			if (right < n && this.compare(this.items[right], this.items[smallest]) < 0) smallest = right;
			if (smallest === i) break;
			this.swap(i, smallest);
			i = smallest;
		}
	}

	private swap(i: number, j: number): void {
		const tmp = this.items[i];
		this.items[i] = this.items[j];
		this.items[j] = tmp;
	}
}
